'use client';
import { createProps, createSplitProps } from '@chakra-ui/utils';

const accordionItemProps = createProps()([
  "isDisabled",
  "id",
  "isFocusable"
]);
const splitAccordionItemProps = createSplitProps(accordionItemProps);
const accordionProps = createProps()([
  "multiple",
  "defaultIndex",
  "index",
  "onChange",
  "collapsible"
]);
const splitAccordionProps = createSplitProps(accordionProps);

export { splitAccordionItemProps, splitAccordionProps };
